import OfferableCoupon from './OfferableCoupon';

export default OfferableCoupon;
